export default __webpack_public_path__ + "static/MediaContentSix-a00e9c73ac63c6ee7e9de91aebddd74a.webp";